const { algoliasearch, instantsearch } = window;

const searchClient = algoliasearch(
  '99WL6VLBXF',
  'd9ee2ce8344b2e124c0d689a41d93bcf'
);

const search = instantsearch({
  indexName: 'BigCommerce - Live',
  searchClient,
  future: { preserveSharedStateOnUnmount: true },
});

let searchBoxRefine = null;

// Add all widgets in a single call
search.addWidgets([
  instantsearch.widgets.configure({
    hitsPerPage: 15,
	clickAnalytics: true, // ✅ This line enables Algolia Analytics
  }),

  instantsearch.widgets.hits({
    container: '#hits',
    templates: {
		item: (hit, { html, components }) => html`
			<a 
				href="https://spiguns.com${hit.url}" 
				class="result-link" 
				data-url="https://spiguns.com${hit.url}">
				<article>
					<img src=${hit.image_url} alt=${hit.name} />
					<div>
						<h1>${components.Highlight({ hit, attribute: 'name' })}</h1>
					</div>
				</article>
			</a>
		`,
    },
  }),

  // Capture refine function for external search
  instantsearch.connectors.connectSearchBox(
    (renderOptions, isFirstRender) => {
      const { refine } = renderOptions;
      searchBoxRefine = refine;
    }
  )({})
]);

// Handle search from parent page
window.addEventListener("message", (event) => {
  if (event.data?.type === "SEARCH_QUERY") {
    const query = event.data.query || "";
    if (searchBoxRefine) {
      searchBoxRefine(query);
    }
  }
});

search.start();

// --- Send height of iframe to parent ---

function sendHeight() {
  const height = document.documentElement.scrollHeight;
  window.parent.postMessage({ type: "IFRAME_HEIGHT", height }, "*");
}

window.addEventListener("load", sendHeight);

search.on("render", () => {
  sendHeight();

  // 🔁 Add click handler to force top-level navigation
  document.querySelectorAll('.result-link').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const targetUrl = link.getAttribute('data-url');
      if (targetUrl) {
        // Force navigation outside iframe
        window.top.location.href = targetUrl;
      }
    });
  });
});










